<div class="page-root">
  <div class="title">
    <mat-icon class="title-icon">{{ data.icon }}</mat-icon>
    <div class="typo-h1">{{ data.title }}</div>
  </div>

  <div class="body">
    @if (data.message) {
      <div class="body-text message">{{ data.message }}</div>
    }

    @if (data.slot; as slot) {
      <div class="slot-list">
        <div class="slot-item">
          <mat-icon>calendar_month</mat-icon>
          <div class="body-text-bold">{{ slot.from | customDate:'cccc, dd.MM.yyyy' }}</div>
        </div>
        <div class="slot-item">
          <mat-icon>schedule</mat-icon>
          <div class="body-text-bold">{{ slot.from | customDate:'HH:mm' }}</div>
        </div>
        @if (slot.employeeName) {
          <div class="slot-item">
            <mat-icon>person</mat-icon>
            <div class="body-text-bold">{{ slot.employeeName }}</div>
          </div>
        }
      </div>
    }

    @if (data.notice) {
      <div class="notice">
        <mat-icon>info</mat-icon>
        <div class="body-text-bold notice-text">{{ data.notice }}</div>
      </div>
    }
  </div>

  <div class="actions">
    <!-- no type="rounded" (the default): mat-dialog-close has a `type` input of its own -->
    <app-text-button [mat-dialog-close]="false" [text]="'button.cancel' | transloco" colorVariant="outlined-neutral" leadingIcon="close"/>
    <app-text-button [mat-dialog-close]="true" [text]="data.confirmLabel" [leadingIcon]="data.confirmIcon" [colorVariant]="data.destructive ? 'cancelled' : 'primary'"/>
  </div>
</div>
